import { render } from "./modal-dynamic.vue?vue&type=template&id=74ed5dbf"
import script from "./modal-dynamic.vue?vue&type=script&lang=js"
export * from "./modal-dynamic.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "74ed5dbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74ed5dbf', script)) {
    api.reload('74ed5dbf', script)
  }
  
  module.hot.accept("./modal-dynamic.vue?vue&type=template&id=74ed5dbf", () => {
    api.rerender('74ed5dbf', render)
  })

}

script.__file = "src/components/modal-dynamic.vue"

export default script